import { User03, Users02 } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

export default {
  name: "profile",
  priority: 1,
  icon: User03,
  menu: ({ t }: { t: TFunction }) => ({
    admin: [
      {
        label: t("User Profiles", { ns: "profile.admin" }),
        icon: <Users02 />,
        child: [
          {
            label: t("Profile", { ns: "profile.shared" }),
            to: "/admin/profile/",
            permission: "profile.profile-builder.view",
          },
          {
            label: t("Inbox", { ns: "core.shared" }),
            to: "/admin/profile/requests",
            permission: "profile.profile-request.view",
          },
        ],
      },
    ],
    settings: [
      {
        label: t("Profile", { ns: "profile.shared" }),
        icon: <User03 />,
        to: "/admin/settings/profile",
        permission: "profile.profile-settings.view",
      },
    ],
  }),
} satisfies ModuleData;
